import React from "react";
import "./Experinace.css";

import { TbBrandReactNative } from "react-icons/tb";
import {
  SiNextdotjs,
  SiIonic,
  SiTailwindcss,
  SiMui,
  SiSass,
  SiCss3,
  SiMongodb,
  SiMongoosedotws,
} from "react-icons/si";
import { BiLogoJavascript } from "react-icons/bi";
import { GrReactjs } from "react-icons/gr";
import { ImHtmlFive } from "react-icons/im";
import { FaNodeJs } from "react-icons/fa";
import { RiBootstrapLine } from "react-icons/ri";

const Expireance = () => {
  return (
    <section id="experience">
      <h5>What Skills I Have</h5>
      <h2>My Skills</h2>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BiLogoJavascript
                style={{ color: "#F7D800" }}
                className="experience__details-icons"
              />
              <div>
                <h4>JavaScript</h4>
                <small className="text-light">Intermmediate</small>
              </div>
            </article>
            <article className="experience__details">
              <GrReactjs
                style={{ color: "#02D1F7" }}
                className="experience__details-icons"
              />
              <div>
                <h4>ReactJS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiNextdotjs
                style={{ color: "#67CAC7" }}
                className="experience__details-icons"
              />
              <div>
                <h4>NextJS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiIonic
                style={{ color: "#4586F7" }}
                className="experience__details-icons"
              />
              <div>
                <h4>Ionic</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <TbBrandReactNative
                style={{ color: "#02D1F7" }}
                className="experience__details-icons"
              />
              <div>
                <h4>React Native</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiTailwindcss
                style={{ color: "#36B7F0" }}
                className="experience__details-icons"
              />
              <div>
                <h4>Tailwind CSS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiMui
                style={{ color: "#007DC5" }}
                className="experience__details-icons"
              />
              <div>
                <h4>Material UI</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <SiSass
                style={{ color: "#C76395" }}
                className="experience__details-icons"
              />
              <div>
                <h4>SCSS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <RiBootstrapLine
                style={{ color: "#7910F1" }}
                className="experience__details-icons"
              />
              <div>
                <h4>BootStrap</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <ImHtmlFive
                style={{ color: "#DD4B25" }}
                className="experience__details-icons"
              />
              <div>
                <h4>HTML</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            {/* </Bounce> */}
            <article className="experience__details">
              <SiCss3
                style={{ color: "#254BDD" }}
                className="experience__details-icons"
              />
              <div>
                <h4>CSS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
          </div>
        </div>

        <div className="experience__backend">
          <h3>Backend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <FaNodeJs
                style={{ color: "#539E43" }}
                className="experience__details-icons"
              />
              <div>
                <h4>NodeJS</h4>
                <small className="text-light">Beginner</small>
              </div>
            </article>
            <article className="experience__details">
              <SiMongodb
                style={{ color: "#4CAA3D" }}
                className="experience__details-icons"
              />
              <div>
                <h4>MongoDB</h4>
                <small className="text-light">Beginner</small>
              </div>
            </article>
            <article className="experience__details">
              <SiMongoosedotws
                style={{ color: "#A03333" }}
                className="experience__details-icons"
              />
              <div>
                <h4>Mongoose</h4>
                <small className="text-light">Beginner</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Expireance;
